// contexts/AuthContext.js
import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import i18n from "../i18n";
const API_URL = process.env.REACT_APP_API_URL;

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [tprmUser, setTprmUser] = useState(null);
  const [caraUser, setCaraUser] = useState(null);
  const [caraAdmin, setCaraAdmin] = useState(null);
  const [tprmUseruser, setTprmUseruser] = useState(null);
  const [loading, setLoading] = useState(true); // Global loading state for auth


  // FIX 7: Removed console.log calls from render body — they ran on every re-render

  // ===========================
  //  ADD: login() that sets caraUser with email from backend
  // Call this in your login screen instead of directly axios.post there
  // ===========================
  const login = async (username, password) => {
    const res = await axios.post(
      `${API_URL}api/login_user/`,
      { username, password },
      { withCredentials: true }
    );

    const data = res.data;

    // IMPORTANT: backend must include `email` in login response (we added earlier)
    // If not present, you can fallback to getCaraUserList() after this.
    setCaraUser((prev) => ({
      ...prev,
      user_id: data.user_id,
      username: data.username,
      role: data.role,
      first_name: data.first_name,
      last_name: data.last_name,
      email: data.email || "",        // 👈 store email here
      package: data.package || "Free", // 👈 optional; depends on your backend,
      agreement_accepted: !!data.agreement_accepted,   // 👈 add this

    }));
  };

  // (Optional) expose logout if you have a logout endpoint
  const logout = async () => {
    try {
      await axios.post(`${API_URL}api/logout_user/`, {}, { withCredentials: true });
    } catch (e) {
      // ignore
    } finally {
      setCaraUser(null);
      setTprmUser(null);
      setCaraAdmin(null);
    }
  };

  // ===========================
  // Your existing fetchers
  // ===========================
  const getTPRMUserList = async () => {
    try {
      const response = await axios.get(
        `${API_URL}api/get_cara_tprm_users/`,
        { withCredentials: true }
      );
      if (response.status === 200 && response.data.length > 0) {
        setTprmUser(response.data[0]); // assuming only one user is returned
      }
    } catch (error) {
      console.error("Error fetching TPRM user:", error);
      setTprmUser(null);
    }
  };

  // Removed individual useEffect for getTPRMUserList


  const getCaraUserList = async () => {
    try {
      const response = await axios.get(
        `${API_URL}api/get_cara_login_users/`,
        { withCredentials: true }
      );

      if (response.status === 200 && response.data.length > 0) {
        // If your backend returns decrypted `email`, keep it.
        // If not, this will still keep whatever came from `login()` above.
        const serverUser = response.data[0];

        setCaraUser(prev => ({
          // keep values from previous (e.g., email from login) if server doesn't send them
          ...prev,
          ...serverUser,
          email: serverUser.email || prev?.email || "", // 👈 ensure email persists
          package: serverUser.package || prev?.package || "Free",
          agreement_accepted: !!(serverUser.agreement_accepted ?? prev?.agreement_accepted), // 👈 keep it in sync

        }));

        console.log("Cara user =>", serverUser);
      }
    } catch (error) {
      console.error("Error fetching Cara user:", error);
      // Do not forcibly null if you've already set it via login()
      // setCaraUser(null);
    }
  };

  // Removed individual useEffect for getCaraUserList



  // TPRm Admin uder tprm urls login which login this details
  const tprmuserlogin = async () => {
    try {
      const response = await axios.get(
        `${API_URL}api/get_cara_tprm_user/`,
        { withCredentials: true }
      );
      if (response.status === 200 && response.data.length > 0) {
        const serverUser = response.data[0];

        setTprmUseruser(prev => ({
          // keep values from previous (e.g., email from login) if server doesn't send them
          ...prev,
          ...serverUser,
          email: serverUser.email || prev?.email || "", // 👈 ensure email persists
          // package: serverUser.package || prev?.package || "Free",
          agreement_accepted: !!(serverUser.agreement_accepted ?? prev?.agreement_accepted), // 👈 keep it in sync

        }));
      }
    } catch (error) {
      console.error("Error fetching TPRM user:", error);
      setTprmUseruser(null);
    }
  };

  // Function to set TPRM User data from login response
  const setTprmUserFromLogin = (userData) => {
    setTprmUseruser({
      user_id: userData.user_id,
      username: userData.username,
      role: userData.role,
      first_name: userData.first_name || "",
      last_name: userData.last_name || "",
      email: userData.email || "",
      // package: data.package || "Free", // 👈 optional; depends on your backend,
      agreement_accepted: !!userData.agreement_accepted,   // 👈 add this


    });
  };

  // Removed individual useEffect for tprmuserlogin

  // Applies the signed-in user's DB-saved language preference, overriding
  // whatever is currently cached in localStorage.cara_lang. That cache is
  // shared globally by i18next-browser-languagedetector, so a language
  // merely PREVIEWED on a public login page (/login, /cara_login,
  // /vrm_login, /tprm_login, /tprm_user_login, /superadmin_login) - which
  // calls i18n.changeLanguage() and gets auto-cached there as a side effect
  // - would otherwise silently leak into and override the actual
  // authenticated account's saved preference.
  //
  // `preferredLanguage` comes straight off api/check-session/'s response
  // (see initAuth below) rather than a separate api/userr-detail/ call,
  // specifically because check-session/ - unlike userr-detail/ - responds
  // successfully even while a session is "pending_2fa" (i.e. on the OTP page,
  // before verification), so the language is corrected as soon as it's
  // knowable at all, not just once the session becomes fully "active".
  const applyPreferredLanguage = (preferredLanguage) => {
    const dbLang = preferredLanguage || 'en';
    if (i18n.language !== dbLang) {
      i18n.changeLanguage(dbLang); // also re-caches localStorage.cara_lang to the correct value
    } else {
      localStorage.setItem('cara_lang', dbLang);
    }
  };

  // Caches the signed-in user's effective timezone (own setting, or their
  // org's default, resolved server-side - see check_session/'s "timezone"
  // field) the same way applyPreferredLanguage caches cara_lang above, so
  // any component can read it synchronously via timezoneFormat.getUserTimezone()
  // without a dedicated fetch or prop drilling.
  const applyAccountTimezone = (timezone) => {
    localStorage.setItem('cara_timezone', timezone || 'UTC');
    window.dispatchEvent(new Event('cara_timezone_updated'));
  };

  //  Consolidated Initial Fetch
  useEffect(() => {
    const initAuth = async () => {
      console.log(" AuthContext: Starting initial user check...");
      setLoading(true);
      try {
        // check-session/ responds (200) with both a status ("pending_2fa" or
        // "active") and this user's preferred_language whenever ANY session
        // - even one still awaiting OTP - exists; it 401s only when there's
        // truly no session at all (a public page). Call it once, upfront:
        // apply the language immediately regardless of status, but only run
        // the per-role detail fetchers below once fully "active".
        const sessionCheck = await axios
          .get(`${API_URL}api/check-session/`, { withCredentials: true })
          .catch(() => null);
        const sessionStatus = sessionCheck?.data?.status; // 'active' | 'pending_2fa' | undefined (no session)
        const sessionActive = sessionStatus === 'active';
        if (sessionStatus === 'active' || sessionStatus === 'pending_2fa') {
          applyPreferredLanguage(sessionCheck.data.preferred_language);
          applyAccountTimezone(sessionCheck.data.timezone);
        }

        // Every per-user detail endpoint (get_cara_tprm_users,
        // get_cara_tprm_user, get_cara_login_users, ...) requires a fully
        // "active" session - the backend's central session gate 401s them
        // while pending_2fa (CARAGRC-001) - so only fetch once MFA is done.
        // OTP success does a full page reload, which remounts AuthProvider
        // and re-runs this against the now-"active" session.
        // OffSec staff aren't CARA/TPRM users - those lookups only 404 for
        // them (role comes from the server's session check, not localStorage).
        const isOffSecStaff = sessionCheck?.data?.role === 'OFFSEC_STAFF';
        const tasks = sessionActive && !isOffSecStaff
          ? [getTPRMUserList(), tprmuserlogin(), getCaraUserList()]
          : [];
        await Promise.allSettled(tasks);
      } catch (error) {
        console.error("AuthContext: Error during initial auth check", error);
      } finally {
        console.log("🔓 AuthContext: Initial user check complete");
        setLoading(false);
      }
    };
    initAuth();
  }, []);



  return (
    <AuthContext.Provider
      value={{
        // state
        tprmUser,
        caraUser,
        tprmUseruser,


        setTprmUseruser,


        setCaraUser,
        setCaraAdmin, // Add this
        setTprmUserFromLogin,
        login,
        logout,
        refreshCaraUser: getCaraUserList,
        setTprmUser,
        setTprmUseruser,
        loading,
        caraAdmin, // Add this
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
